import React from 'react';

const OPTION_LABELS = {
  front_fabric: 'Tissu du devant',
  front_fabric_middle: 'Tissu du milieu',
  front_fabric_bottom: 'Tissu du bas',
  back_fabric: 'Tissu du dos',
  ribbon_fabric: 'Tissu du ruban',
  ribbon: 'Fil de couture',
};

export function ConfigurationSummary({ configuration, className = '' }) {
  const options = Array.isArray(configuration?.options) ? configuration.options.filter(Boolean) : [];
  if (!options.length) return null;
  return (
    <dl className={`mt-2 space-y-1.5 rounded-xl bg-secondary/45 p-2.5 text-left ${className}`}>
      {options.map((option, index) => (
        <div key={`${option.group || option.label}-${option.option_id || index}`} className="min-w-0">
          <dt className="font-sans text-[10px] uppercase tracking-[0.12em] text-muted-foreground">
            {option.group === 'ribbon' ? 'Fil de couture' : option.label || (
              option.group === 'front_fabric' && options.some(choice => choice.group === 'front_fabric_middle')
                ? 'Tissu du haut' : OPTION_LABELS[option.group] || option.group
            )}
          </dt>
          <dd className="flex min-w-0 items-start gap-2 font-sans text-xs font-medium text-foreground">
            {option.hex && <span aria-hidden="true" className="mt-1 h-2 w-2 shrink-0 rounded-full border border-border" style={{ backgroundColor: option.hex }} />}
            <span className="min-w-0 break-words">{option.value || option.option_name || option.name}</span>
          </dd>
        </div>
      ))}
    </dl>
  );
}

export function formatOrderTotal(value) {
  const amount = Number(value);
  return value != null && Number.isFinite(amount) ? `${amount.toFixed(2)} €` : '—';
}

export function isMadeToOrder(item) {
  return Boolean(item.madeToOrder || item.made_to_order || item.configuration || item.configurationId || item.configuration_id);
}
